<template>
  <v-dialog :retain-focus="false" :value="isShowZaloZns" max-width="1000" persistent>
    <validation-observer v-slot="{ handleSubmit }">
      <v-card class="quick-view">
        <v-card-title class="font-weight-bold px-5 text-left">
          Vui lòng chọn đối tượng của tin nhắn
          <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="pa-0">
            <v-row align="center" class="ml-0 mb-4">
              <v-col
                  class="pa-0"
                  v-for="(i, key) in dataContact.childCustomer"
                  :key="key"
                  cols="auto">
                <button
                    class="btn-child-name"
                    :class="i.id == dataSend.customerId ? 'active' : ''"
                    @click="selectChildCustomer(i)">{{ i.fullName }}
                </button>
              </v-col>
            </v-row>
          </div>

          <validation-provider
              v-slot="{ errors }"
              name="Mẫu tin nhắn"
              rules="required"
          >
            <v-autocomplete
                item-disabled="disable"
                outlined
                :items="templateSmsLists"
                item-text="text"
                item-value="templateId"
                label="Chọn mẫu tin nhắn"
                v-model="templateSmsSelected"
                eager
                :error-messages="errors"
                return-object
                clearable
            ></v-autocomplete>
          </validation-provider>

          <v-card-actions class="px-0 group-btn--form">
            <v-btn
                class="mr-0"
                size="x-small"
                rounded
                color="#999"
                @click="closeModal">
              Hủy
            </v-btn>
            <v-spacer/>
            <v-btn
                class="mr-0"
                size="x-small"
                rounded
                color="blue"
                @click.prevent="handleSubmit(sendZaloZns)">
              Gửi
            </v-btn>
          </v-card-actions>

        </v-card-text>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<style lang="css" scoped>
/deep/ .icon-child-name {
  position: inherit !important;
  padding-right: 10px;
  top: unset !important;
  right: unset !important;
}
.quick-view table thead tr th {
  font-size: 16px !important;
}

.quick-view table tr td {
  font-size: 13px !important;
}
.btn-child-name {
  border: 1px solid;
  border-radius: 4px;
  margin-right: 10px;
  padding: 2px 10px;
}
.btn-child-name.active {
  color: #0085FF;
  border: 1px solid #0085FF;
}
.group-btn--form {
  max-width: 175px;
}
</style>

<script>
import ContactRepository from "../../../repositories/ContactRepository";

export default {
  props: {
    isShowZaloZns: {
      default: () => ({})
    },
    dataContact: {
      default: () => ({})
    }
  },
  data() {
    return {
      templateSmsLists: [
        {
          text: 'Gia sư demo 1',
          code: 'gia_su_demo_1',
          templateId: '259146',
          tagCode: 'GiaSuDemo1',
          disable: false
        },
        {
          text: 'THPT demo 1',
          code: 'thpt_demo_1',
          templateId: '261928',
          tagCode: 'ThptDemo1',
          disable: false
        }
      ],
      dataSend: {
        customerId: this.dataContact?.childCustomer && this.dataContact?.childCustomer.length
            ? this.dataContact.childCustomer[0]?.id : '',
        customerName: this.dataContact?.childCustomer && this.dataContact?.childCustomer.length
            ? this.dataContact.childCustomer[0]?.fullName : '',
        templateId: '',
      },
      templateSmsSelected: {}
    };
  },
  created() {

  },
  methods: {
    closeModal() {
      Bus.$emit('close-zalo-zns-modal')
    },
    async sendZaloZns() {
      if (!this.dataSend.customerName || _.isEmpty(this.templateSmsSelected)) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Vui lòng chọn đầy đủ thông tin!'
        });
        return
      }
      this.appLoadingData(true);
      let body = {
        "tagCode": this.templateSmsSelected?.tagCode,
        "contactId": this.dataContact.id,
        "phone": this.dataContact?.mobile.replace('0', 84), // VN 0 -> 84
        "template_id": this.templateSmsSelected.templateId,
        "template_data": {
          "customer_name": this.dataSend?.customerName, // tên con
          "customer_id": this.dataContact?.mobile.slice(-5) // 5 số cuối sdt contact
        }
      }
      const res = await ContactRepository.sendZaloZns(body);
      console.log('res: ', res)
      this.appLoadingData(false);
      if (res?.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        });
      } else {
        this.$swal({
          title: 'Success!',
          text: _.get(res, 'message', 'Gửi tin zalo Zns thành công!'),
          timer: 2000
        })
      }
    },
    selectChildCustomer (customer) {
      this.dataSend.customerId = customer?.id
      this.dataSend.customerName = customer?.fullName
      // this.dataSend.mobile = customer?.mobile
    }
  }
};
</script>
